import PropTypes from 'prop-types';
import React from 'react';
import styles from 'styles/input.scss';
import S from './styles.scss';

class TimeInput extends React.Component {
  handleChange = (elm) => {
    const val = (elm && elm.target && elm.target.value) || '';
    this.props.onChange(val);
  }

  renderLabel = (lbl, errs) => {
    const style = errs ? `${S.label} ${S.errorLabel}` : S.label;

    return (
      <h6 className={style}>{lbl}</h6>
    );
  }

  renderInput = (val, props) => {
    const style = `${styles.inputElement} ${S.input}`;

    return (
      <input
        {...props}
        className={style}
        type="time"
        value={val}
        onChange={this.handleChange}
      />
    );
  }

  renderErrors = errs => (
    <div className={styles.error}>
      <span className={S.errorMsg}>{errs}</span>
    </div>
  )

  render = () => {
    const { label, value, errors, className, ...props } = this.props;
    const errs = errors.join(', ');
    const style = errs ? `${className} ${styles.errored}` : className;

    return (
      <div className={style}>
        {this.renderLabel(label, errs)}
        {this.renderInput(value, props)}
        {this.renderErrors(errs)}
      </div>
    );
  }
}

TimeInput.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  className: PropTypes.string,
};

TimeInput.defaultProps = {
  label: '',
  value: '',
  errors: [],
};

export default TimeInput;



// WEBPACK FOOTER //
// ./client/app/shared/components/TimeInput/index.jsx